/**
 * ErrorBoundary (docs/service/37 §6.3) — ловит краши рендера, шлёт telemetry,
 * показывает мягкий экран вместо белой страницы. Раньше в admin его не было —
 * любой краш компонента ронял весь UI без следа.
 */
import { Component, type ErrorInfo, type ReactNode } from 'react';

import { trackError } from '@/lib/track';

interface Props {
  children: ReactNode;
}
interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  override state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    try {
      const frame = info.componentStack?.split('\n')[1]?.trim();
      trackError(error.message || 'render_error', frame, window.location?.pathname);
    } catch {
      /* телеметрия не должна мешать показу экрана ошибки */
    }
  }

  override render(): ReactNode {
    if (!this.state.hasError) return this.props.children;
    return (
      <div
        style={{
          minHeight: '60vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 12,
          padding: 24,
          textAlign: 'center',
        }}
      >
        <div style={{ fontSize: 40 }}>😕</div>
        <div style={{ fontSize: 18, fontWeight: 600 }}>Что-то сломалось</div>
        <div style={{ color: '#6e6d6c', maxWidth: 360 }}>
          Мы уже знаем об ошибке. Обновите страницу — обычно это помогает.
        </div>
        <button
          onClick={() => window.location.reload()}
          style={{
            marginTop: 8,
            padding: '8px 20px',
            borderRadius: 8,
            border: 'none',
            background: '#2563eb',
            color: '#fff',
            fontSize: 15,
            cursor: 'pointer',
          }}
        >
          Обновить
        </button>
      </div>
    );
  }
}
